(function (aimi_user, $, app, undefined) {
  // Private object
  var __this = {};
  aimi_user.setting = {};

  /**
   * User Api calls
   */
  app.apis['user'] = function () {
    let user = {};

    return {
      'get': function () {
        if (app.localStorage.getItem('userAuth')) {
          user = JSON.parse(app.localStorage.getItem('userAuth'));
        }
        user.subscriptionPlan = user.plan;
        // Calculate trial days and plan expired
        user.trialDays = false;
        user.planExpired = false;

        let dateTrailing = user['date_trialing'];

        if (!_.isEmpty(dateTrailing)) {
          let diff = moment().diff(moment(dateTrailing.date), 'days');
          if (14 - diff) {
            user.trialDays = 14 - diff;
          }
          if (diff > 14) {
            user.planExpired = true;
          }
        }
        return user;
      },
      'set': function (data) {
        user = data;
        app.localStorage.setItem('userAuth', JSON.stringify(user));
        console.log(user);
        app.setCookie('userAuth', JSON.stringify(user), 365);
      },
      'hasAuth': function () {
        let userAuth = app.localStorage.getItem('userAuth');
        if (!_.isEmpty(userAuth)) {
          user = JSON.parse(userAuth);
          return true;
        }

        return false;
      },
      'login': function (requestData) {
        this.logout();
        return app.postRequest('/api/public/customer/login', requestData, function (response) {
          console.log(response);
          user = response.user;
          user.authToken = response.auth_token;
          app.localStorage.setItem('userAuth', JSON.stringify(user));
          app.setCookie('userAuth', JSON.stringify(user), 365);
        }, function (response) {
          console.log(response);
        });
      },
      'logout': function () {
        user = {};
        app.localStorage.removeItem('userAuth');
        app.removeCookie('userAuth');
      },
      'update': function (requestData) {
        return app.putRequest('/api/user/' + user.id, requestData, function (response) {
          user = response.user;
          user.authToken = response.auth_token;
          app.localStorage.setItem('userAuth', JSON.stringify(user));
          app.setCookie('userAuth', JSON.stringify(user), 365);
        });
      },
      'password': function (requestData) {
        return app.postRequest('/api/public/customer/send-reset-email', requestData,
            function (response) {
            },
            function (response) {
            }
        );
      },
      'passwordReset': function (requestData) {
        requestData.reset_hash = app.getParameterByName('hash');
        return app.postRequest('/api/public/customer/reset-password', requestData,
            function (response) {
            },
            function (response) {
            }
        );
      },
      'collaboratorLogin': function (requestData) {
        return app.postRequest('/api/public/customer/collaborator-login', requestData,
            function (response) {
              user = response.collaborator;
              user.authToken = response.auth_token;
              app.localStorage.setItem('userAuth', JSON.stringify(user));
              app.setCookie('userAuth', JSON.stringify(user), 365);
            }, function (response) {
            }
        );
      },

      'register': function (requestData) {
        return app.postRequest('/api/public/customer/new', requestData,
            function (response) {
              user = response.user;
              user.authToken = response.auth_token;
              app.localStorage.setItem('userAuth', JSON.stringify(user));
              app.setCookie('userAuth', JSON.stringify(user), 365);
            },
            function (response) {
            }
        );
      },
      'defaultCalendar': function (requestData) {
        return app.postRequest('/api/user/default-calendar', requestData,
            function (response) {
            },
            function (response) {
            }
        );
      },
      industries: function () {
        return app.getRequest('/api/public/campaign/industry', {},
            function (response) {
            },
            function (response) {
            }
        );
      },

      message: function () {
        let query = $.Deferred(),
            appTransport = app.transport();

        appTransport.setEvent('onSuccess', function (response) {
          return query.resolve(response);
        }).setEvent('onError', function (response) {
          return query.reject();
        });

        appTransport.get('/api/user/message');
        return query.promise();
      },
      getSocial: function () {
        let query = $.Deferred(),
            appTransport = app.transport();

        appTransport.setEvent('onSuccess', function (response) {
          return query.resolve(response);
        }).setEvent('onError', function (response) {
          return query.reject();
        });

        appTransport.get('/api/user/social');
        return query.promise();
      },
      'subscribe': function (requestData) {
        let query = $.Deferred(),
            appTransport = app.transport();

        appTransport.setEvent('onSuccess', function (response) {
          return query.resolve();
        }).setEvent('onError', function (response) {
          return query.reject(response.message.message);
        });

        appTransport.post('/api/billing/subscribe', requestData);
        return query.promise();
      },
      'downgrade': function (requestData) {
        let query = $.Deferred(),
            appTransport = app.transport();

        appTransport.setEvent('onSuccess', function (response) {
          return query.resolve();
        }).setEvent('onError', function (response) {
          return query.reject(response.message.message);
        });

        appTransport.post('/api/billing/downgrade', requestData);
        return query.promise();
      },

      'checkSubscription': function () {
        let query = $.Deferred(),
            appTransport = app.transport();

        appTransport.setEvent('onSuccess', function (response) {
          return query.resolve(response);
        }).setEvent('onError', function (response) {
          return query.reject();
        });

        appTransport.get('/api/billing/check-subscription');
        return query.promise();
      },
      'affiliate': function (requestData) {
        let query = $.Deferred(),
            appTransport = app.transport();

        appTransport.setEvent('onSuccess', function (response) {
          user.affiliate_data = response.user['affiliate_data'];
          user.is_brand_partner = response.user['is_brand_partner'];
          user.mdcdot_id = response.user['mdcdot_id'];
          app.localStorage.setItem('userAuth', JSON.stringify(user));
          return query.resolve();
        }).setEvent('onError', function (response) {
          return query.reject(response.message.message);
        });

        appTransport.post('/api/user/brand-partner', requestData);
        return query.promise();
      }
    }
  }();

  aimi_user.loginCallback = function (response) {
    if (response.user.status === 'ONBOARDING') {
      window.location.replace('/onboard');
    } else {
      if(!app.isEmpty(response.error)) {
        app.notify('error', response.message);
      } else{
        window.location.reload(true);
      }
    }
  }

  aimi_user.collaboratorLoginCallback = function (response) {
    window.location.reload(true);
  }

  aimi_user.onBoardingCallback = function (response) {
    const user = app.apis['user'].get();
    user.status  = 'ACTIVE';
    app.apis['user'].set(user);
    window.location.reload(true);
  }

  aimi_user.resetPasswordUpdateCallback = function (response) {
    app.notifyEl.update({'message': response.message, progress: 90});
    setTimeout(function () {
      app.redirect('/login');
    },2000);
  }

  /**
   * Update Plan class on body ( need to be called where user plan is being updated for user object)
   */
  aimi_user.updatePlan = function () {
    let currentPlan = aimi_user.getApi().get()['plan'];
    $('body')
        .removeClass('user-plan-free user-plan-pro user-plan-proplus')
        .addClass(`user-plan-${currentPlan}`);
    aimi_user_subscription.setPlan(currentPlan);
  };

  /**
   * Check if user on free plan
   */
  aimi_user.isFree = function () {
    return aimi_user.getApi().get()['plan'] === 'free';
  };

  /**
   * Check if user on basic plan
   */
  aimi_user.isBasic = function () {
    return aimi_user.getApi().get()['plan'] === 'basic';
  };

  /**
   * Check if user on pro plan
   */
  aimi_user.isPro = function () {
    return aimi_user.getApi().get()['plan'] === 'pro';
  };

  // Initialize User Setting.
  aimi_user.setting = {
    init: function () {
      const $form = $('form[name=user-setting]');
      const userApi = app.apis['user'];
      const user = userApi.get();
      const page = _.template(app.templates['global__timzone']);
      const $page = $(page({}));

      // Set timezone select options
      $('select[name="timezone"]').append($page);

      this.setValues($form, user);


      app.initSimpleBar(document.getElementById('tab_block_1'));

      // Dot User

    },

    setValues: function ($form, values) {
      $('input[name=firstname]', $form).val(values.firstname);
      $('input[name=lastname]', $form).val(values.lastname);
      $('input[name=email]', $form).val(values.email);
      $('select[name=timezone]', $form).val(values.timezone);
    },


    updateCallBack: function (response) {
      app.notifyEl.update({'message': response.message, progress: 90});
    }
  }

  aimi_user.password = {
    resetCallback: function (response) {
      const $form = $('form[name=password-reset-form]');
      const message = "Please check your email. A message has been sent to your email with instructions on how to reset your password.";
      app.notifyEl.update({'message': message, progress: 70});
      $form.addClass('needs-validation');
      $form.removeClass('was-validated');
      $form[0].reset();
    },
    resetUpdateCallback: function (response) {
      const $form = $('form[name=password-reset-update-form]');
      app.notifyEl.update({'message': response.message, progress: 70});
      $form.addClass('needs-validation');
      $form.removeClass('was-validated');
      $form[0].reset();
    }
  }

  aimi_user.setPassword = {
    init: async function() {
      const $form = $('form[name="password-reset-update-form"]');

      let $password = $(':input[name=password]', $form)[0];
      let $confirmPassword = $(':input[name=confirm_password]', $form)[0];

      __this.validatePassword = function () {
        if ($password.value !== $confirmPassword.value) {
          $confirmPassword.setCustomValidity("Passwords Don't Match");
        } else {
          $confirmPassword.setCustomValidity('');
        }
      };

      $password.onchange = __this.validatePassword;
      $confirmPassword.onkeyup = __this.validatePassword;
    }
  }
  aimi_user.onboarding = {
    init: async function () {
      const user = app.apis['user'].get();
      const $industry = $('select[name=industry]');
      const $blankCalendar = $(':input[name="switchIndustry"]');

      $blankCalendar.off('change').on('change', function() {
        const $this = $(this);
        if($this.is(":checked")) {
          $industry.val('').trigger('change');
          $industry.attr('disabled', 'disabled');

        } else {
          $industry.removeAttr('disabled');
        }
      });

      $industry.attr('disabled', 'disabled');
      $industry.select2({
        dropdownCssClass: 'industry-select2-dropdown',
        selectionCssClass: 'industry-select2-selection',
        theme: 'bootstrap-5'
      });

      const industries = await app.apis['user'].industries();
      $industry.removeAttr('disabled');

      const $industryOptionGroup = $('optgroup[label="Industry"]', $industry);
      const $demoOptionGroup = $('optgroup[label="Company"]', $industry);

      $.each(industries.data, function (index, value) {
        if (value.demo === '1') {
          $('<option />').attr('value', value.id).html(value.name).appendTo($demoOptionGroup);
        } else {
          $('<option />').attr('value', value.id).html(value.name).appendTo($industryOptionGroup);
        }
      });

      $industry.trigger('change');
    }
  }


  /**
   * Logout navigation click event
   */
  $(document).off('click.logout-nav-click').on('click.logout-nav-click', '#nav__logout, .logout-link', function (e) {
    let userApi = app.apis['user'];
    userApi.logout();
    window.location.href = '/';
    return e.preventDefault();
  });

}(window.aimi_user = window.aimi_user || {}, jQuery, PreBuilt));

